import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import SubpageShell from "components/common/SubpageShell";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";
import styles from "../../styles/weitere-leistungen/WeitereLeistungen.module.css";

interface ServiceBlock {
  title: string;
  text: string;
}

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common", "weitere-leistungen"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const WeitereLeistungenPage: NextPage = () => {
  const { t } = useTranslation("weitere-leistungen");
  const services: ServiceBlock[] = t("services", { returnObjects: true }) as ServiceBlock[];

  return (
    <SubpageShell
      title={t("global.websiteTitle")}
      description={t("global.websiteDescription")}
      path="/weitere-leistungen"
      eyebrow={t("eyebrow")}
      heading={t("heading")}
      subtitle={t("subtitle")}
    >
      <div className={styles.container}>
        <div className={styles.grid}>
          {services.map((service: ServiceBlock) => (
            <article key={service.title} className={styles.card}>
              <h2 className={styles.cardTitle}>{service.title}</h2>
              <p className={styles.cardText}>{service.text}</p>
            </article>
          ))}
        </div>

        <div className={styles.ctaPanel}>
          <p className={styles.ctaText}>{t("cta.text")}</p>
          <a
            className={styles.ctaButton}
            href={t("common:global.calendlyLink")}
            target="_blank"
            rel="noopener noreferrer"
            data-umami-event="booking-link-click"
            aria-label={`${t("cta.button")} (opens in new tab)`}
          >
            {t("cta.button")}
          </a>
        </div>
      </div>
    </SubpageShell>
  );
};

export default WeitereLeistungenPage;
